import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShipDetailComponent } from './ship-detail.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
  ],
  declarations: [ShipDetailComponent],
  entryComponents: [ShipDetailComponent]
})
export class ShipDetailModule { }
